// extracted by mini-css-extract-plugin
export var companyDescription = "company-description-module--company-description--9Dz8Y";